// extracted by mini-css-extract-plugin
export default {"active":"Header_active__1nEqp","link":"Header_link__w6ob9"};